const addMissingZero = (date) => {
	if (String(date).length === 1) {
		return `0${date}`;
	}
	return date;
};

export const getTransformedDate = (days, format) => {
	const currentDate = new Date();
	const newDate = new Date(currentDate.setDate(currentDate.getDate() + days));
	const day = addMissingZero(newDate.getDate());
	const month = addMissingZero(newDate.getMonth() + 1);
	const year = newDate.getFullYear();
	let transformedNewDate = "";
	switch (format.toLowerCase()) {
		case "mm/dd/yyyy":
			transformedNewDate = `${month}/${day}/${year}`;
			break;
		case "dd/mm/yyyy":
			transformedNewDate = `${day}/${month}/${year}`;
			break;
		case "yyyy-mm-dd":
			transformedNewDate = `${year}-${month}-${day}`;
			break;
		default:
	}
	return transformedNewDate;
};

export const getTimeZone = () => {
	return Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
};
